export const BackForAppConfiguration = {
    production :{
        ApplicationId: "be5vX46tPuX4OrqmbOnO7vgueY40Z5juUs98xPDM",
        ServerUrl: "https://parse-moons.futura.healthcare",
        JavascriptKey: "4TBRVYfzjH8uesrcCPNex9l65As3fbkymOAZ1tPW",
        ParseUrl: "https://parse-moons.futura.healthcare"
    }
}
//moons-admin